<section class="summary">
  <h3 class="mb-4" *ngIf="!isMobile">Summary</h3>
  <ul class="timeline timeline-split">
    <li class="timeline-item">
      <!-- <div class="timeline-info"></div> -->
      <div class="timeline-marker"></div>
      <div class="timeline-content">
        <p>Insurance type</p>
        <p class="timeline-title">{{ formData?.metadata?.displayTitle || formData?.title }}</p>
      </div>
    </li>
    <ng-container *ngIf="formIsLoaded">
      <ng-container *ngFor="let summaryItem of formData.components[0].fieldGroup; index as sectionIndex; last as lastSummaryItem">
        <ng-container *ngIf="summaryItem?.fieldArray; else noRepeat">
          <ng-container *ngFor="let repeatAnswer of summaryItem?.fieldArray?.fieldGroup || []; index as repeatIndex; last as lastRepeat">
            <app-summary-item
              *ngIf="repeatIndex < (summaryItem?.formControl?.value?.length || 0) && !summaryItem?.hide"
              [formGroup]="mainForm"
              [currentFormGroup]="currentForm"
              [summaryItem]="repeatAnswer"
              [valid]="summaryItemValid(summaryItem, repeatIndex)"
              [inProgress]="isCurrentPageInProgress(summaryItem, sectionIndex, repeatIndex)"
              [hasRepeats]="true"
              [showProgressIndicator]="showProgressIndicator(summaryItem, sectionIndex, repeatIndex)"
              [subindex]="repeatIndex"
              [isLast]="lastSummaryItem && lastRepeat"
              [visited]="checkVisited(sectionIndex)"
              (pageChange)="handlePageChange(sectionIndex, repeatIndex)"
              (resumeProgress)="resumeProgress()"
              (removeItem)="removeItem(sectionIndex, repeatIndex)"
            >
            </app-summary-item>
          </ng-container>
        </ng-container>
        <ng-template #noRepeat>
          <app-summary-item
            *ngIf="!summaryItem?.hide"
            [formGroup]="mainForm"
            [summaryItem]="summaryItem"
            [valid]="summaryItemValid(summaryItem)"
            [inProgress]="isCurrentPageInProgress(summaryItem, sectionIndex)"
            [hasRepeats]="false"
            [showProgressIndicator]="showProgressIndicator(summaryItem, sectionIndex)"
            [subindex]="0"
            [isLast]="lastSummaryItem"
            [visited]="checkVisited(sectionIndex)"
            (pageChange)="handlePageChange(sectionIndex)"
            (resumeProgress)="resumeProgress()"
          >
          </app-summary-item>
        </ng-template>
      </ng-container>
    </ng-container>
  </ul>
</section>
